module.exports = __webpack_public_path__ + "static/media/radio-blue.d25368dd.svg";